<template>
  <div class="popover">
    <input
      :disabled="disable"
      type="text"
      ref="input"
      v-model="query"
      @keydown.up="up"
      @keydown.down="down"
      @keydown.enter="selectItem"
      placeholder="Nombre de establecimiento..."
      @blur="limpiarBusqueda"
    />
    <div class="options" ref="optionsList" v-if="matches && query.length > 0">
      <ul>
        <li
          v-for="(match, index) in matches"
          :key="index"
          :class="{ selected: selected == index }"
          @click="itemClicked(index)"
          v-text="match[filterby]"
        ></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filterby: {
      type: String
    },
    title: {
      default: "Select One...",
      type: String
    },
    shouldReset: {
      type: Boolean,
      default: true
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      itemHeight: 39,
      selectedItem: null,
      selected: 0,
      query: "",
      visible: false,
      items: []
    };
  },
  watch: {
    query: function() {
      this.$emit("change", this.query);
    }
  },
  methods: {
    limpiarBusqueda() {
      setTimeout(() => (this.query = ""), 400);
    },
    toggleVisible() {
      this.visible = !this.visible;
      setTimeout(() => {
        this.$refs.input.focus();
      }, 50);
    },
    itemClicked(index) {
      this.selected = index;
      this.selectItem();
    },
    selectItem() {
      if (!this.matches.length) {
        return;
      }
      this.selectedItem = this.matches[this.selected];
      this.visible = false;
      if (this.shouldReset) {
        this.query = "";
        this.selected = 0;
      }
      this.$emit("selected", JSON.parse(JSON.stringify(this.selectedItem)));
    },
    up() {
      if (this.selected == 0) {
        return;
      }
      this.selected -= 1;
      this.scrollToItem();
    },
    down() {
      if (this.selected >= this.matches.length - 1) {
        return;
      }
      this.selected += 1;
      this.scrollToItem();
    },
    scrollToItem() {
      this.$refs.optionsList.scrollTop = this.selected * this.itemHeight;
    }
  },
  computed: {
    establecimientos() {
      return this.$store.getters.getEstablecimientos;
    },
    matches() {
      if (this.query == "") {
        return [];
      }
      return this.establecimientos.filter(item =>
        item[this.filterby].toLowerCase().includes(this.query.toLowerCase())
      );
    }
  }
};
</script>

<style scoped>
.close {
  position: absolute;
  right: 10px;
  top: 3px;
  background: none;
  border: none;
  font-size: 30px;
  color: lightgrey;
  cursor: pointer;
}
.popover {
  width: 100%;
  border: 1px solid #c0def5;
  position: absolute;
  top: 23px;
  left: 0;
  right: 0;
  background: #fff;
  border-radius: 3px;
  text-align: center;
  z-index: 999 !important;
}
.popover input {
  width: 100%;
  padding-top: 6px;
  padding-bottom: 6px;
  font-size: 16px;
  border-radius: 3px;
  border: none;
  padding-left: 8px;
}
.options {
  max-height: 150px;
  overflow-y: scroll;
  margin-top: 5px;
  z-index: 1000;
}
.options ul {
  list-style-type: none;
  text-align: left;
  padding-left: 0;
}
.options ul li {
  border-bottom: 1px solid #e5f1f9;
  padding: 10px;
  cursor: pointer;
  background: #fff;
}
.options ul li:first-child {
  border-top: 2px solid #d6d6d6;
}
.options ul li:not(.selected):hover {
  background: #e5f1f9;
  color: #245ea3;
}
.options ul li.selected {
  background: #245ea3;
  color: #fff;
  font-weight: 600;
}
@media (max-width: 990px) {
  .popover {
    top: 0px;
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/generales/Autocompletado.vue